import { Button, Popover } from "antd";
import { ArrowsAltOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface button {
  onClick: any;
}

const ViewButton = ({ onClick }: button) => {
  const [t] = useTranslation("common");
  const content = <div>{t("view")}</div>;

  return (
    <>
      <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
        <Button
          className="Button"
          type="text"
          icon={
            <ArrowsAltOutlined style={{ color: "#212121", fontSize: "16px" }} />
          }
          onClick={onClick}
          size={"small"}
        />
      </Popover>
    </>
  );
};

export default ViewButton;
